import { render, staticRenderFns } from "./CashupHistorySales.vue?vue&type=template&id=486069ec&"
import script from "./CashupHistorySales.vue?vue&type=script&lang=js&"
export * from "./CashupHistorySales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports